import React from 'react';
import Tooltip from '@mui/material/Tooltip';

export default function ValueLabelComponent(props) {
  const { children, value } = props;
  const title = (typeof value === 'string' || typeof value === 'number')
    ? value
    : (value && typeof value === 'object' && 'label' in value)
      ? String(value.label)
      : String(value);
  return (
    <Tooltip enterTouchDelay={0} placement="top" title={title}>
      {children}
    </Tooltip>
  );
}
